import React from "react";
import { useQuery } from "react-query";
import { Navigate, useParams } from "react-router-dom";


import popupServices from "../../services/popup";
import PageHeading from "../../components/PageHeading";
import DCard from "../../components/DCard";
import DSpinner from "../../components/DSpinner";
import FormikContainer from "../../components/Formik/FormikContainer";
import FieldContainer from "../../components/Formik/FieldContainer";
import { Form } from "formik";


const ViewPopup = ({ title }) => {
  const { id } = useParams();

  const { data, isLoading, error } = useQuery(["getPupupMessage", id], () => {
    return popupServices.getPupupMessage(id);
  });
  if (error || isNaN(Number(id)) || !id) {
    return <Navigate to="/404" />;
  }

  const initialValues = {
    title: "",
    content: "",
    img_url: "",
  };
  const onSubmit = () => {};

  return (
    <div>
      <PageHeading>{title}</PageHeading>
      <DCard className={isLoading ? "min-h-[400px]" : ""}>
        {isLoading ? (
          <DSpinner />
        ) : (
          <FormikContainer initialValues={initialValues} onSubmit={onSubmit}>
            {({ values, isSubmitting, setFieldValue }) => (
              <Form>
                <div>
                  <div className="grid  gap-4">
                    <FieldContainer
                      name="title"
                      type="text"
                      value={data.data.title}
                      label="العنوان"
                      id="title"
                      disabled
                    />

                    <FieldContainer
                      name="content"
                      type="textarea"
                      value={data.data.content}
                      label="محتوى الرسالة "
                      id="content"
                      disabled
                    />
                    <img
                      width={300}
                      height={300}
                      src={data.data.img_url}
                      alt={data.data.img_url}
                    />
                  </div>
                </div>
              </Form>
            )}
          </FormikContainer>
        )}
      </DCard>
    </div>
  );
};

export default ViewPopup;
